import { ReactNode } from 'react';
import { SnackbarOrigin, useSnackbar } from 'notistack';

export enum NotificationStatus {
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum NotificationLevel {
  MAJOR,
  MINOR,
}

export interface Notification {
  message: ReactNode;
  status?: NotificationStatus;
  level?: NotificationLevel;
}

export function useNotification(): (notification: Notification) => void {
  const { enqueueSnackbar } = useSnackbar();

  function addNotification(notification: Notification) {
    const status = notification.status || NotificationStatus.DEFAULT;
    const level = notification.level || NotificationLevel.MAJOR;
    const origin: SnackbarOrigin =
      level === NotificationLevel.MAJOR
        ? { horizontal: 'right', vertical: 'top' }
        : { horizontal: 'center', vertical: 'bottom' };
    enqueueSnackbar(notification.message, {
      variant: status,
      anchorOrigin: origin,
    });
  }
  return addNotification;
}
